import registerPrompt from "emun.auth/register-retailer-prompt";

export default $parse => ({
  scope: false,
  link(scope, element, attr) {
    const ngModel = {
      open(e) {
        return registerPrompt(attr).then(
          args => $parse(attr.onRegistered)(scope, args),
          args => $parse(attr.onDismissed)(scope, args)
        );
      }
    };

    if (attr.ngModel) $parse(attr.ngModel).assign(scope, ngModel);

    const $targets = attr.registerRetailerPromptSelector
      ? element.find(attr.registerRetailerPromptSelector)
      : element;
    $targets.on("click", ngModel.open);
  }
});
